import { render, staticRenderFns } from "./PiPortfolioInformation.vue?vue&type=template&id=0b334468"
import script from "./PiPortfolioInformation.vue?vue&type=script&lang=js"
export * from "./PiPortfolioInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports